import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7287d841"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"padding":"0.7rem"}
}
const _hoisted_2 = { class: "white-radius" }
const _hoisted_3 = { class: "img-con" }
const _hoisted_4 = { class: "cls-flex" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"width":"5rem"},
  class: "desc"
}, "昵称", -1))
const _hoisted_6 = { class: "black" }
const _hoisted_7 = {
  class: "cls-flex",
  style: {"margin-top":"0.5rem"}
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"width":"5rem"},
  class: "desc"
}, "ID", -1))
const _hoisted_9 = { class: "black" }
const _hoisted_10 = {
  class: "cls-flex",
  style: {"margin-top":"0.5rem"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"width":"5rem"},
  class: "desc"
}, "电话", -1))
const _hoisted_12 = { class: "black" }
const _hoisted_13 = {
  class: "white-radius",
  style: {"padding-top":"0"}
}
const _hoisted_14 = { class: "border-btm" }
const _hoisted_15 = { class: "cls-con" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, "合计数量", -1))
const _hoisted_17 = { class: "price" }
const _hoisted_18 = { class: "btn-con" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_serve_item = _resolveComponent("serve-item")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.order)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_van_image, {
                src: _ctx.order.memberHeadimg,
                width: "6rem",
                height: "6rem",
                radius: "3rem"
              }, null, 8, ["src"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.order.orderName), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.order.memberId), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.order.orderPhone), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.order.pdcArr, (item, i) => {
                return (_openBlock(), _createBlock(_component_serve_item, {
                  key: item.id,
                  item: item
                }, null, 8, ["item"]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.order.pdcArr.length) + "次", 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_van_popup, {
      show: true,
      position: "bottom",
      overlay: false,
      "lock-scroll": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_van_button, {
            color: "#D8C14F",
            round: "",
            block: "",
            onClick: _withModifiers(_ctx.btn_click, ["stop"])
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 核销订单 ")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    })
  ], 64))
}